<template>
  <v-edit-dialog @open="open" @save="save">
    {{ value }}
    <template v-slot:input>
      <v-select
        v-if="field.isSelect"
        v-model="changeValue"
        :items="field.values"
        :rules="[]"
        :label="field.name"
        single-line
        counter
      />

      <v-text-field
        v-else
        v-model="changeValue"
        :rules="[]"
        :label="field.name"
        single-line
        counter
      />
    </template>
  </v-edit-dialog>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
    },
    propertyValue: {
      type: String,
    },
  },
  data: () => ({
    value: null,
    changeValue: null,
  }),
  created() {
    this.value = this.propertyValue;
  },
  methods: {
    open() {
      this.changeValue = this.value;
    },
    save() {
      this.value = this.changeValue;
      this.$emit('update', this.value);
    },
  },
};
</script>

<style>
</style>
